import ReceiptReportBase from "./ReceiptReportBase";

export default function WaterReceiptReportPage() {
  return <ReceiptReportBase scope="water" />;
}
